// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type { IHttpApi, IHttpApiFetchConfig } from '@cian/http-api';
import type {
  IGetVillageListSummaryRequest,
  TGetVillageListSummaryModel,
  IMappers,
  TGetVillageListSummaryResponse,
  IGetVillageListSummaryResponse,
  IGetVillageListSummaryResponseError,
} from './types';

export const defaultConfig: TGetVillageListSummaryModel = {
  apiType: 'private',
  assertStatusCodes: [200, 400],
  hostType: 'api',
  method: 'POST',
  microserviceName: 'countryside-search',
  pathApi: '/v1/get-village-list-summary/',
  requestType: 'json',
} as TGetVillageListSummaryModel;

export function createGetVillageListSummaryModel(
  parameters: IGetVillageListSummaryRequest,
): TGetVillageListSummaryModel {
  return {
    ...defaultConfig,
    parameters,
  };
}

export interface IGetVillageListSummaryOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: IGetVillageListSummaryRequest;
}

export async function fetchGetVillageListSummary<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: IGetVillageListSummaryOptions<TResponse200, TResponse400>): Promise<
  TGetVillageListSummaryResponse | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = await httpApi.fetch(createGetVillageListSummaryModel(parameters), config);
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IGetVillageListSummaryResponse);
    }
    if (statusCode === 400) {
      return mappers[400](response as IGetVillageListSummaryResponseError);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as TGetVillageListSummaryResponse;
}
